//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

/* global angular: false */

(function() {
  const curalate = angular.module('curalate');

  curalate.directive('productList', () => ({
    restrict: 'E',
    scope: {
      onChange: '&',
      itemData: '=',
      page: '@',
      products: '=',
      itemId: '@?',
      itemType: '@',
    },
    replace: true,
    template: require('@legacy-components/common/product-list/product-list.html'),
    controller: ['$scope', '$attrs', 'ToastNotificationService', 'UniversalImageActionsService', 'UniversalImageActionsView',
      function($scope, $attrs, ToastNotificationService, UniversalImageActionsService, UniversalImageActionsView) {
        $scope.model = {
          features: {
            withSpatialTagging: angular.isDefined($attrs.withSpatialTagging),
            withBeautify: angular.isDefined($attrs.withBeautify), // TODO Will be supported when fanreel is ported over
                            // TODO Should bulk-editing be a feature, or should it be set implicitly if multiple photos are passed in?
          },
        };

        $scope.acornBrokenImage = require('@images/acorn-broken.svg');

        $scope.model.launchModal = function() {
          UniversalImageActionsService.launch(UniversalImageActionsView.Productize.name, {
            itemId: $scope.itemId || $scope.itemData.id,
            itemType: $scope.itemType,
            page: $scope.page,
          });
        };

        const updateProducts = function(products) {
          let message;
          let changeParameters;

          if (products && !angular.equals(products, $scope.products)) {
            message = (products.length === 0) ? 'Success! All products have been removed.' : 'Success! Products updated.';
            ToastNotificationService.success({ title: message });

            changeParameters = {
              'itemData': $scope.itemData,
              'oldProducts': $scope.products,
              'newProducts': products,
            };
            $scope.onChange(changeParameters);

            $scope.products = products || $scope.products;
          }
        };

        $scope.$on('uia:modal:closed', ($event, response) => {
          if (
                            response.productsChanged &&
                            response.universalItemId.indexOf($scope.itemType.toLowerCase()) > -1 &&
                            response.universalItemId.indexOf($scope.itemId) > -1
                        ) {
            if ($scope.itemType.toLowerCase() === 'like2buy') {
                                // Workaround for like2buy's update/featuring API requiring a list of products
                                // The Like2Buy update item API requires this field to feature a product, but it is unused
                                // (the only used fields are destinationURL and isFeatured)
              _(response.products).each((product) => {
                product.id = 0;
              });
            }

            updateProducts(response.products);
          }
        });
      },
    ],
  }));
})();
